import {Checkbox, FormControlLabel, MenuItem, TextField as MaterialTextField, TextField} from "@mui/material";
import {CKEditor} from "@ckeditor/ckeditor5-react";
import {ClassicEditor} from "@ckeditor/ckeditor5-editor-classic";
import {useEffect, useState} from "react";
import {useFormik} from "formik";
import List from "@ckeditor/ckeditor5-list/src/list";
import Placeholder from "ckeditor5-placeholder";
import Essentials from "@ckeditor/ckeditor5-essentials/src/essentials";
import Bold from "@ckeditor/ckeditor5-basic-styles/src/bold";
import Italic from "@ckeditor/ckeditor5-basic-styles/src/italic";
import Paragraph from "@ckeditor/ckeditor5-paragraph/src/paragraph";
import SimpleUploadAdapter from "@ckeditor/ckeditor5-upload/src/adapters/simpleuploadadapter";
import ImageUpload from "@ckeditor/ckeditor5-image/src/imageupload";
import Image from "@ckeditor/ckeditor5-image/src/image";
import Heading from "@ckeditor/ckeditor5-heading/src/heading";
import Link from "@ckeditor/ckeditor5-link/src/link";
import AutoLink from "@ckeditor/ckeditor5-link/src/autolink";
import Indent from "@ckeditor/ckeditor5-indent/src/indent";
import IndentBlock from "@ckeditor/ckeditor5-indent/src/indentblock";
import Font from "@ckeditor/ckeditor5-font/src/font";
import Alignment from "@ckeditor/ckeditor5-alignment/src/alignment";
import Underline from "@ckeditor/ckeditor5-basic-styles/src/underline";
import Strikethrough from "@ckeditor/ckeditor5-basic-styles/src/strikethrough";
import Table from "@ckeditor/ckeditor5-table/src/table";
import TableToolbar from "@ckeditor/ckeditor5-table/src/tabletoolbar";
import HorizontalLine from "@ckeditor/ckeditor5-horizontal-line/src/horizontalline";
import BlockQuote from "@ckeditor/ckeditor5-block-quote/src/blockquote";
import {BASE_DOMAIN_URL} from "../../../../API/util";
import * as React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import {ADD, ATTENDING_STATUSES, EDIT, getUserSettings, RESALE, VIEW} from "../../../Utils/constants";
import Button from "@mui/material/Button";
import {LoadingButton} from "@mui/lab";
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers-pro";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import Autocomplete from "@mui/material/Autocomplete";
import {Cancel} from "@mui/icons-material";
import Chip from "@mui/material/Chip";
import {saveGroupEmail, updateGroupEmail} from "../../../../API/eventsOverview";
import {dateToString} from "../../../Utils/dateUtils";
import {validateEmail} from "../../../Utils/validations";
import {TimePicker} from "@mui/x-date-pickers/TimePicker";
import Swal from "sweetalert2";

const editorConfiguration = {
    plugins: [
        List,
        Placeholder,
        Essentials,
        Bold,
        Italic,
        Paragraph,
        SimpleUploadAdapter,
        ImageUpload,
        Image,
        Heading,
        Link,
        AutoLink,
        Indent,
        IndentBlock,
        Font,
        Alignment,
        Underline,
        Strikethrough,
        Table,
        TableToolbar,
        HorizontalLine,
        BlockQuote,
    ],
    toolbar: [
        "heading",
        "|",
        "Placeholder",
        "|",
        "fontColor",
        "fontBackgroundColor",
        "|",
        "outdent",
        "indent",
        "|",
        "bold",
        "italic",
        "underline",
        "strikethrough",
        "|",
        "link",
        "horizontalLine",
        "blockQuote",
        "uploadImage",
        "|",
        "bulletedList",
        "numberedList",
        "|",
        "alignment:left",
        "alignment:right",
        "|",
        "insertTable",
        "|",
        "undo",
        "redo",
    ],
    alignment: {
        options: ["left", "right"],
    },
    placeholderProps: {
        types: [
            "FROM_FULLNAME",
            "FROM_FIRSTNAME",
            "FROM_LASTNAME",
            "EMAIL_SUBJECT",
            "FROM_EMAIL",
            "EVENT_DATE",
            "EVENT_TIME_FROM",
            "EVENT_TIME_TO",
            "EVENT_ADDRESS",
            "EVENT_PARKING_INFO",
            "NETWORK_DIRECTOR_1_FIRSTNAME",
            "NETWORK_DIRECTOR_1_FULLNAME",
            "NETWORK_DIRECTOR_2_FIRSTNAME",
            "NETWORK_DIRECTOR_2_FULLNAME",
        ],
    },
    placeholderBrackets: {
        open: "[",
        close: "]",
    },
    table: {
        contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
    },
    simpleUpload: {
        // The URL that the images are uploaded to.
        uploadUrl: `${BASE_DOMAIN_URL}/api/events/uploadimage`,
        // Enable the XMLHttpRequest.withCredentials property.
        withCredentials: false,
        // Headers sent along with the XMLHttpRequest to the upload server.
        headers: {
            Authorization: localStorage.getItem("token"),
        },
    },
};

const EventOverviewGroupEmailForm = (props) => {
    const {user} = getUserSettings();
    const {event, mails, type, selectedGroupEmail, activeUsers, networkCoordinator, networkDirectors, handleClose} = props;
    const [participantOptions, setParticipantOptions] = useState([]);
    const [template, setTemplate] = useState("");
    const [_editor, setEditor] = useState(null);
    const [participants, setParticipants] = useState([]);
    const [bcc, setBcc] = useState([]);
    const [cc, setCc] = useState([]);
    const [resaleUsers, setResaleUsers] = useState([]);
    const [selectedStatuses, setSelectedStatuses] = useState([]);
    const [showScheduleFields, setShowScheduleFields] = useState(false);

    const getCoreErrors = (values) => {
        let errors = {};

        if (!values.sender_id) {
            errors.sender_id = 'Required';
        }

        if (!values.subject) {
            errors.subject = 'Required';
        }

        if (!values.content) {
            errors.content = 'Required';
        }

        if (!values.participants || values?.participants?.length === 0) {
            errors.participants = 'Required';
        }

        return errors;
    };

    const submitGroupEmail = (values, onDone) => {
        let cc_data = {};
        let nd = networkDirectors.map(nd => nd.job_email);
        let directors = [];
        let coordinator = '';
        let others = [];

        cc.forEach(email => {
            if (nd.includes(email)) {
                directors.push(email);
            } else if (networkCoordinator.user_email === email) {
                coordinator = email;
            } else {
                others.push(email);
            }
        })

        if (directors.length > 0) {
            cc_data.directors = directors;
        }

        if (coordinator !== '') {
            cc_data.coordinator = coordinator;
        }

        if (others.length > 0) {
            cc_data.others = others;
        }

        let postValues = {...values};

        delete postValues.send_to_network_coordinator;
        delete postValues.send_to_network_directors;

        let postData = {
            ...postValues,
            scheduled_time: postValues.scheduled_time && typeof postValues.scheduled_time === "object" ?
                dateToString(postValues.scheduled_time, 'yyyy-MM-dd HH:mm:ss') : (postValues.scheduled_time || null),
            participants: {person_ids: participants.map((p) => p.person_id)},
            bcc: JSON.stringify(bcc),
            cc: JSON.stringify(cc_data),
        };

        if (type === ADD) {
            postData.event_id = event.event_id;

            saveGroupEmail(postData).then(() => {
                handleClose(true);
                onDone();
            }).catch(() => {
                handleClose();
                onDone();
            })
        } else {
            updateGroupEmail(selectedGroupEmail.event_id, selectedGroupEmail.event_group_email_id, postData).then(() => {
                handleClose(true);
                onDone();
            }).catch(() => {
                handleClose();
                onDone();
            })
        }
    };

    const formik = useFormik({
        validate: (values) => {
            let errors = getCoreErrors(values);

            if (showScheduleFields) {
                if (!values.scheduled_time) {
                    errors.scheduled_time = 'Required';
                } else {
                    let schedule_time = new Date(values.scheduled_time);

                    if (isNaN(schedule_time.getTime())) {
                        errors.scheduled_time = 'Invalid Date';
                    }
                }
            }

            return errors;
        },
        onSubmit: ((values, {setSubmitting}) => {
            submitGroupEmail(values, () => setSubmitting(false));
        }),
        initialValues: {
            participants: [],
            bcc: [],
            cc: [],
            sender_id: "",
            subject: "",
            content: "",
            scheduled_time: "",
            send_to_network_directors: false,
            send_to_network_coordinator: false,
            is_content_ready: false,
        },
    });
    const {setFieldValue} = formik;

    useEffect(() => {
        let _participants = [];
        const {participants_details} = event;

        setParticipantOptions(participants_details?.map((participant) => {
            return {
                person_id: participant.person_id,
                name: participant.person_firstname + " " + participant.person_lastname,
                email: participant.job_email,
                answer: participant.answer.value
            }
        }));

        if ((type === VIEW || type === EDIT) && selectedGroupEmail !== null) {
            const {participants} = selectedGroupEmail;
            _participants = participants?.map((participant) => {
                return {
                    person_id: participant.person_id,
                    name: participant.person_firstname + " " + participant.person_lastname,
                    email: participant.job_email,
                    answer: participant.answer
                }
            })

            setFieldValue('sender_id', selectedGroupEmail.sender_id);
            setFieldValue('subject', selectedGroupEmail.subject);
            setFieldValue('content', selectedGroupEmail.content);
            setFieldValue('scheduled_time', selectedGroupEmail.scheduled_time);
            setFieldValue('is_content_ready', selectedGroupEmail.is_content_ready === 1);
            setFieldValue('send_to_network_directors', selectedGroupEmail.send_to_network_directors === 1);
            setFieldValue('send_to_network_coordinator', selectedGroupEmail.send_to_network_coordinator === 1);
            setFieldValue('bcc', selectedGroupEmail.bcc);
            setFieldValue('cc', selectedGroupEmail.cc);
            setFieldValue('participants', _participants);

            setParticipants(_participants);
            setBcc(selectedGroupEmail.bcc);
            setCc(selectedGroupEmail.cc);
            setShowScheduleFields(!!selectedGroupEmail.scheduled_time);
        }
    }, [type, selectedGroupEmail, event, setFieldValue]);

    useEffect(() => {
        if (activeUsers) {
            let _resaleUsers = [];
            let isLoggedInUserActiveResale = false;

            activeUsers.forEach(activeUser => {
                if (activeUser.pipelines?.length > 0) {
                    let resalePipeline = activeUser.pipelines.filter((pipeline) => pipeline.pipeline_type === RESALE);

                    if (resalePipeline?.length > 0) {
                        _resaleUsers.push(activeUser);

                        if (activeUser.user_id === user.user_details.user_id) {
                            setFieldValue("sender_id", activeUser.user_id);
                            isLoggedInUserActiveResale = true;
                        }
                    }
                }
            });

            setResaleUsers(_resaleUsers);

            if (!isLoggedInUserActiveResale) {
                setCc([user.user_details.user_email]);
            }
        }
    }, [activeUsers]);

    const getTemplate = (e) => {
        const templateId = e.target.value;
        const template = mails.main.templates.find((t) => t.template_id === templateId);
        formik.setFieldValue("subject", template.template_subject || template.template_name);
        formik.setFieldValue("content", template.template_body);
        setTemplate(templateId);
    };

    const handleSendLater = () => {
        setShowScheduleFields(true);
    };

    const handleSendNow = () => {
        const coreErrors = getCoreErrors(formik.values);

        if (Object.keys(coreErrors).length > 0) {
            formik.setTouched({
                ...formik.touched,
                sender_id: true,
                subject: true,
                content: true,
                participants: true,
            }, false);

            let combinedErrors = {...formik.errors, ...coreErrors};
            delete combinedErrors.scheduled_time;
            formik.setErrors(combinedErrors);

            return;
        }

        Swal.fire({
            title: 'Send email now?',
            text: 'Your changes will be saved and the email will be sent immediately. This cannot be undone. Do you want to send now?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#1976d2',
            cancelButtonColor: '#e8f1fb',
            confirmButtonText: 'Send Now',
            cancelButtonText: 'Cancel',
            didOpen: (popup) => {
                const cancelButton = popup.querySelector('.swal2-cancel');

                if (cancelButton) {
                    cancelButton.style.color = '#545454';
                }
            },
        }).then((result) => {
            if (result.isConfirmed) {
                setShowScheduleFields(false);
                formik.setSubmitting(true);
                submitGroupEmail(
                    {...formik.values, scheduled_time: null, send_now: true, is_content_ready: true},
                    () => formik.setSubmitting(false)
                );
            }
        });
    };

    const handleAttendanceStatusFilter = (item) => {
        setSelectedStatuses(prev => {
            const exists = prev.some(status => status.value === item.value);

            let newFilters = [];

            if (exists) {
                newFilters = prev.filter(status => status.value !== item.value);
            } else {
                newFilters = [...prev, item];
            }

            let filteredParticipants = [];

            filteredParticipants = participantOptions.filter(participant => {
                // Check if participant's answer matches any selected filter
                return newFilters.some(filter =>
                    participant.answer === filter.value
                );
            });

            setParticipants(filteredParticipants);
            formik.setFieldValue('participants', filteredParticipants);

            return newFilters;
        });
    }

    return (
        <Box
            sx={{
                "& .MuiTextField-root": {m: 0.5, width: "100%"},
            }}
        >
            <form onSubmit={formik.handleSubmit}>
                <Grid container spacing={0}>
                    <Grid item xs={12}  sx={{padding: "0px 0px 10px 0px"}}>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                            <Chip
                                label={"Filter participants:"}
                                sx={{
                                    borderRadius: 0,
                                    fontWeight: 600,
                                    background: 'transparent'
                                }}
                            />
                            {ATTENDING_STATUSES.map((item) => {
                                const isSelected = selectedStatuses?.some(s => s.value === item.value);
                                return (<Chip
                                    key={item.value}
                                    label={item.title}
                                    onClick={() => handleAttendanceStatusFilter(item)}
                                    variant={isSelected ? "filled" : "outlined"}
                                    color={isSelected ? item.color : "default"}
                                    sx={{
                                        borderRadius: 1,
                                        fontWeight: isSelected ? 600 : 400,
                                        '&:hover': { transform: 'translateY(-1px)' },
                                        transition: 'all 0.2s',
                                    }}
                                    disabled={type === VIEW}
                                />)
                            }
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12}  sx={{padding: "0px 0px 10px 0px"}}>
                        <Autocomplete
                            multiple
                            id="participants"
                            options={participantOptions}
                            getOptionLabel={(option) => `${option.name} (${option.email})`}
                            value={participants}
                            onChange={(_event, newValue) => {
                                setParticipants(newValue);

                                // Update Formik's field value
                                formik.setFieldValue('participants', newValue);
                                formik.setFieldTouched('participants', true, false);
                                // Validate the field
                                formik.validateField('participants');
                            }}
                            filterSelectedOptions
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="BCC*"
                                    placeholder="BCC*"
                                    error={formik.touched.participants && Boolean(formik.errors.participants)}
                                    helperText={formik.touched.participants && formik.errors.participants}
                                />
                            )}
                            renderTags={(value, getTagProps) =>
                                value.map((option, index) => (
                                    <Chip
                                        label={`${option.name}`}
                                        {...getTagProps({ index })}
                                        deleteIcon={<Cancel />}
                                    />
                                ))
                            }
                            isOptionEqualToValue={(option, value) => option.person_id === value.person_id}
                            disabled={type === VIEW}
                        />
                    </Grid>
                    <Grid item xs={12}  sx={{padding: "0px 0px 10px 0px"}}>
                        <Autocomplete
                            multiple
                            freeSolo
                            options={[]}
                            value={bcc}
                            onChange={(_event, newValue) => {
                                const validEmails = newValue.filter(item => validateEmail(item));
                                const uniqueEmails = [...new Set(validEmails)];

                                setBcc(uniqueEmails);
                                formik.setFieldValue('bcc', uniqueEmails);
                                formik.setFieldTouched('bcc', true, false);
                                formik.validateField('bcc');

                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Additional BCC"
                                    placeholder="Enter email address and press enter to add them"
                                    error={formik.touched.bcc && Boolean(formik.errors.bcc)}
                                    helperText={formik.touched.bcc && formik.errors.bcc}
                                />
                            )}
                            disabled={type === VIEW}
                        />
                    </Grid>
                    <Grid item xs={12}  sx={{padding: "0px 0px 10px 0px"}}>
                        <Autocomplete
                            multiple
                            freeSolo
                            options={[]}
                            value={cc}
                            onChange={(_event, newValue) => {
                                const validEmails = newValue.filter(item => validateEmail(item));
                                const uniqueEmails = [...new Set(validEmails)];

                                setCc(uniqueEmails);
                                formik.setFieldValue('cc', uniqueEmails);
                                formik.setFieldTouched('cc', true, false);
                                formik.validateField('cc');
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="CC"
                                    placeholder="Enter email address and press enter to add them"
                                    error={formik.touched.cc && Boolean(formik.errors.cc)}
                                    helperText={formik.touched.cc && formik.errors.cc}
                                />
                            )}
                            disabled={type === VIEW}
                        />
                    </Grid>
                    <Grid item xs={4}  sx={{padding: "0px 10px 10px 10px"}}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={formik.values.send_to_network_directors}
                                    onChange={(_e, value) => {
                                        //set nd email in cc field.
                                        setCc(prev => {
                                            let newCc = prev;
                                            const nds = networkDirectors?.map(nd => nd.job_email);

                                            if (value) {
                                                const exists = prev.some(cc => nds.includes(cc));

                                                if (!exists && nds?.length > 0) {
                                                    nds.forEach(nd => {
                                                        if (validateEmail(nd)) {
                                                            newCc = [...prev, nd];
                                                        }
                                                    });
                                                }

                                            } else {
                                                newCc = prev.filter(cc => !nds.includes(cc));
                                            }

                                            return newCc;
                                        });
                                        setFieldValue("send_to_network_directors", value);
                                    }}
                                    disabled={type === VIEW}
                                />
                            }
                            label="Add Network Directors"
                        />
                    </Grid>
                    <Grid item xs={4} sx={{padding: "0px 10px 10px 10px"}}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={formik.values.send_to_network_coordinator}
                                    onChange={(_e, value) => {
                                        setCc(prev => {
                                            let newCc = [];

                                            if (value) {
                                                const exists = prev.some(cc => cc === networkCoordinator?.user_email);

                                                if (!exists && networkCoordinator && validateEmail(networkCoordinator?.user_email)) {
                                                    newCc = [...prev, networkCoordinator.user_email];
                                                }

                                            } else {
                                                newCc = prev.filter(cc => cc !== networkCoordinator?.user_email);
                                            }

                                            return newCc;
                                        });

                                        setFieldValue("send_to_network_coordinator", value);
                                    }}
                                    disabled={type === VIEW}
                                />
                            }
                            label="Add Network Coordinators"
                        />
                    </Grid>
                    <Grid item xs={12} sx={{padding: "0px 0px 10px 0px"}}>
                        <TextField
                            id='sender'
                            select
                            name='sender_id'
                            label='Sender*'
                            value={formik.values.sender_id}
                            onChange={(e) => {
                                const {value} = e.target;
                                const isLoggedInUserActiveResale = user?.user_details?.user_id === value;
                                const exists = cc.some(item => item === user.user_details.user_email);

                                if (!isLoggedInUserActiveResale) {
                                    if (!exists) {
                                        setCc([...cc, user.user_details.user_email]);
                                    }
                                } else {
                                    if (exists) {
                                        setCc(cc.filter(cc => cc !== user.user_details.user_email));
                                    }
                                }

                                formik.handleChange(e);
                            }}
                            onBlur={formik.handleBlur}
                            error={formik.touched.sender_id && Boolean(formik.errors.sender_id)}
                            helperText={formik.touched.sender_id && formik.errors.sender_id}
                            disabled={type === VIEW}
                        >
                            {resaleUsers.map((option) => (
                                <MenuItem key={option.user_id}
                                          value={option.user_id}>
                                    {option.user_firstname + " " + option.user_lastname}
                                </MenuItem>
                            ))}
                            disabled={type === VIEW}
                        </TextField>
                    </Grid>
                    <Grid item xs={6} sx={{padding: "0px 0px 10px 0px"}}>
                        <TextField
                            id='template'
                            name='template'
                            select
                            label='Select Template'
                            value={template}
                            onChange={getTemplate}
                            disabled={type === VIEW}
                        >
                            {mails &&
                                mails.main.templates
                                    .filter(
                                        (option) =>
                                            option.created_by !== null &&
                                            option.created_by === user?.user_details?.user_id
                                    )
                                    .map((option) => (
                                        <MenuItem key={option.template_id}
                                                  value={option.template_id}>
                                            {option.template_name}
                                        </MenuItem>
                                    ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={6} sx={{padding: "0px 0px 10px 10px"}}>
                        <TextField
                            label='Subject*'
                            variant='outlined'
                            id='subject'
                            name='subject'
                            value={formik.values.subject}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.subject && Boolean(formik.errors.subject)}
                            helperText={formik.touched.subject && formik.errors.subject}
                            disabled={type === VIEW}
                        />
                    </Grid>
                    <Grid item xs={12} sx={{padding: "0px 0px 10px 4px"}}>
                        <CKEditor
                            id='content'
                            name='content'
                            editor={ClassicEditor}
                            config={editorConfiguration}
                            data={formik.values.content}
                            onReady={setEditor}
                            onChange={(_event, editor) => {
                                formik.setFieldValue("content", editor.getData());
                            }}
                            sx={{
                                border: "1px solid red",
                            }}
                            disabled={type === VIEW}
                        />
                        {formik.touched.content && formik.errors.content &&
                            <p style={{color: 'red', margin: '4px 14px 0px', fontSize: '0.75rem'}}>
                                {formik.errors.content}
                            </p>
                        }
                    </Grid>
                    {
                        type !== VIEW &&
                        <Grid item xs={12} sx={{padding: "0px 0px 10px 0px"}}>
                            <Button
                                variant="contained"
                                onClick={handleSendNow}
                                disabled={formik.isSubmitting}
                                sx={{marginRight: '10px'}}
                            >
                                Send Now
                            </Button>
                            <Button
                                variant="outlined"
                                onClick={handleSendLater}
                            >
                                Send Later
                            </Button>
                        </Grid>
                    }
                    {
                        showScheduleFields &&
                        <>
                            <Grid item xs={4} sx={{padding: "0px 0px 10px 0px"}}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DatePicker
                                        label='Scheduled Date*'
                                        inputFormat='dd/MM/yyyy'
                                        disableMaskedInput
                                        value={formik.values.scheduled_time} // Set the initial value
                                        onChange={(newValue) => {
                                            setFieldValue("scheduled_time", newValue);
                                        }}
                                        renderInput={(startProps) => (
                                            <MaterialTextField
                                                {...startProps}
                                                sx={{
                                                    width: "100%",
                                                }}
                                                padding={{
                                                    top: "1px"
                                                }}
                                                error={formik.submitCount > 0 && !!formik.errors.scheduled_time}
                                            />
                                        )}
                                        disabled={type === VIEW}
                                    />
                                    {
                                        formik.touched.scheduled_time && formik.errors.scheduled_time &&
                                        <div
                                            style={{
                                                color: "red",
                                                fontSize: "0.75rem",
                                                margin: "4px 14px 0px",
                                            }}>{formik.errors.scheduled_time}</div>
                                    }
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={4} sx={{padding: "0px 10px"}}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <TimePicker
                                        label='Scheduled Time*'
                                        name="scheduled_time"
                                        inputFormat='HH:mm'
                                        ampm={false}
                                        disableMaskedInput
                                        value={formik.values.scheduled_time} // Set the initial value
                                        onChange={(newValue) => {
                                            setFieldValue("scheduled_time", newValue);
                                        }}
                                        renderInput={(startProps) => (
                                            <MaterialTextField
                                                {...startProps}
                                                sx={{
                                                    width: "100%",
                                                }}
                                                padding={{
                                                    top: "1px"
                                                }}
                                                error={formik.submitCount > 0 && !!formik.errors.scheduled_time}
                                            />
                                        )}
                                        disabled={type === VIEW}
                                    />
                                    {
                                        formik.touched.scheduled_time && formik.errors.scheduled_time &&
                                        <div
                                            style={{
                                                color: "red",
                                                fontSize: "0.75rem",
                                                margin: "4px 14px 0px",
                                            }}>{formik.errors.scheduled_time}</div>
                                    }
                                </LocalizationProvider>
                            </Grid>
                        </>
                    }
                    <Grid item xs={4} sx={{padding: "10px 10px"}}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={formik.values.is_content_ready}
                                    onChange={(_e, value) => {
                                        setFieldValue("is_content_ready", value);
                                    }}
                                    disabled={type === VIEW}
                                />
                            }
                            label="Content Ready"
                        />
                    </Grid>
                    <Grid item xs={12} textAlign={'right'}>
                        <Button variant="outlined" onClick={handleClose} sx={{margin: '10px'}}>
                            Cancel
                        </Button>
                        {
                            type !== VIEW &&
                            <LoadingButton variant="contained" type="submit" loading={formik.isSubmitting}>
                                Save
                            </LoadingButton>
                        }
                    </Grid>
                </Grid>
            </form>
        </Box>
    )
}

export default EventOverviewGroupEmailForm;